<template>
  <div class="empty">
    <img src="https://aichongqing-assets.fooyotravel.com/common/no-content.png"/>
    <div class="empty-info">{{ $t('common.networkErrorMsg') }}</div>
    <div class="empty-btn" @click="handleTap">{{ $t('common.reload') }}</div>
  </div>
</template>

<script>
export default {
  methods: {
    handleTap () {
      this.$emit('reload')
    }
  }
}
</script>

<style lang="scss">
.empty {
  padding-top: 107px;
  text-align: center;
}

.empty img {
  width: 82px;
  height: 112px;
  display: block;
  margin: 0 auto 12px;
}

.empty-info {
  font-size: 14px;
  color: #888888;
}

.empty-btn {
  width: 160px;
  height: 40px;
  border-radius: 20px;
  background-color: #f8a909;
  font-size: 14px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 60px auto 0;
}
</style>
